import { useEffect } from "react";
import { useLocation } from "react-router-dom";


function Legal() {

    const location = useLocation();

    useEffect(() => {
        const hash = location.hash;
        if (hash) {
        const element = document.querySelector(hash);
        if (element) {
            setTimeout(() => {
            element.scrollIntoView({ behavior: 'smooth' });
            }, 100);
        }
        }
    }, [location]);

    return ( 
        <main style={styles.container} >
            <h1 style={styles.h1}>Mentions Légales</h1>
            <p>L’utilisation de ce site implique l’acceptation pleine et entière des conditions générales d’utilisation décrites dans les présentes mentions légales.</p>
            <h2 style={styles.h2} >Éditeur du site</h2>
            <ul style={styles.ul} >
                <li>Nom de l’association : Pour Guillaume</li>
                <li>Forme juridique : Association régie par la loi du 1er juillet 1901</li>
                <li>Adresse du siège social : Le Domaine 05500 St-Bonnet en Champsaur</li>
                <li>Numéro SIRET : 528 045 016 00011</li>
                <li>RNA : W052002715</li>
                <li>Responsable de la publication : Tristan SMITH (Fonction dans l’association, Vice-Président)</li>
                <li>Adresse email : assopourguillaume@gmail.com</li>
            </ul>
            <h2 style={styles.h2} >Hébergeur du site</h2>
            <ul style={styles.ul}>
                <li>Nom de l’hébergeur : OVH</li>
                <li>Adresse : OVH - 2 rue kellermann BP 80157 59053 ROUBAIX CEDEX 1 - France</li>
                <li>Téléphone : +33 9 72 10 10 07</li>
                <li>Site web : www.ovh.com</li>
            </ul>
            <h2 style={styles.h2} >Propriété intellectuelle</h2>
            <p>Les contenus présents sur ce site (textes, images, logos, vidéos, etc.) sont la propriété exclusive de l’association Pour Guillaume ou sont utilisés avec l’autorisation de leurs titulaires de droits. Toute reproduction ou réutilisation sans autorisation est interdite.</p>
            <p>Les logos des partenaires et sponsors présents sur ce site sont affichés avec leur autorisation respective.</p>
            <h2 style={styles.h2} >Responsabilité</h2>
            <p>
                L'association Pour Guillaume met tout en œuvre pour assurer l’exactitude des informations diffusées sur ce site. Toutefois, elle ne peut garantir l’exactitude, la complétude ou l’actualité des informations fournies.
                L’utilisateur reconnaît utiliser les informations disponibles sur le site sous sa responsabilité exclusive.
            </p>
            <h2 style={styles.h2} id="donnees-personnelles">Droit à l'image</h2>
            <p>
                Lors de l’inscription à un tournoi organisé par l’association, le responsable de l’équipe (dans le cas d’une équipe adulte) ou le parent/représentant légal (dans le cas d’un participant de moins de 14 ans) certifie avoir informé tous les participants concernés que des photographies ou vidéos pourront être réalisées lors de l’événement.
                En soumettant l’inscription, il donne, au nom de l’ensemble des joueurs ou de l’enfant concerné, l’autorisation à l’association d’utiliser ces images à des fins de communication et de promotion (site internet, affiches, journaux, publications ou réseaux sociaux), dans le cadre exclusif des activités de l’association.
                Aucune image ne sera utilisée à des fins commerciales ni transmise à des tiers sans autorisation supplémentaire.    
            </p>
            <h2 style={styles.h2} id="donnees-personnelles" >Données personnelles</h2>
            <p>Les données collectées via le formulaire d’inscription au tournoi (nom, prénom, adresse e-mail, etc.) sont utilisées exclusivement pour la gestion de l’événement et ne sont en aucun cas transmises à des tiers.  
                Conformément à la loi « Informatique et Libertés » du 6 janvier 1978 modifiée et au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants :
            </p>
            <ul style={styles.ul}>
                <li>Droit d’accès</li>
                <li>Droit de rectification</li>
                <li>Droit à l’effacement</li>
                <li>Droit à la limitation du traitement</li>
                <li>Droit d’opposition</li>
            </ul>
            <p>
                Pour exercer ces droits, vous pouvez contacter :
                Association Pour Guillaume – assopourguillaume@gmail.com
                <br/>Les données sont conservées pendant une durée maximale de 1 an après le dernier contact.
            </p>
        </main>
     );
}

const styles = {
    container: {
        height: 'auto',
    },
    h1: {
        fontFamily: 'Poppins, sans-serif',
        fontSize: 30,
        fontWeight: 900,
    },
    h2: {
        fontFamily: 'Poppins, sans-serif',
        fontSize: 25,
        fontWeight: 900,
        marginBottom: 8,
        marginTop: 20,
        textAlign: 'left',
    }, 
    ul: { 
        listStyleType: 'square',
        listStylePosition: 'inside',
        paddingLeft: 20,
        backgroudColor: 'red',
    },
}
 
export default Legal;